module.exports = __webpack_public_path__ + "static/media/error.07f9118d.png";